import { render, staticRenderFns } from "./TodayAssignedTable.vue?vue&type=template&id=9504f910&"
import script from "./TodayAssignedTable.vue?vue&type=script&lang=js&"
export * from "./TodayAssignedTable.vue?vue&type=script&lang=js&"
import style0 from "./TodayAssignedTable.vue?vue&type=style&index=0&id=9504f910&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports